<template>
  <div class="flvh265div-4">
    <div class="flvh265info">
      <div>
        <div style="position: relative" :class="{'containeritem': 'true','videoFullScreen': isFullScreen}">
          <Button size="small" @click="cameraCtrl(0,'left')" v-if="cameraTypeList[0]===1"
                  style="z-index:9999;position: absolute;color: #000000;left: 0;top: 50%;transform: translateY(-50%);background-color: #0C5977;border: none">
            <Icon type="ios-arrow-back"/>
          </Button>
          <Button size="small" @click="cameraCtrl(0,'right')" v-if="cameraTypeList[0]===1"
                  style="z-index:9999;position: absolute;color:  #000000;right: 0;top: 50%;transform: translateY(-50%);background-color: #0C5977;border: none">
            <Icon type="ios-arrow-forward"/>
          </Button>
          <Button size="small" @click="cameraCtrl(0,'up')" v-if="cameraTypeList[0]===1"
                  style="z-index:9999;position: absolute;color:  #000000;top: 0;left: 50%;transform: translateX(-50%);background-color: #0C5977;border: none">
            <Icon type="ios-arrow-up"/>
          </Button>
          <Button size="small" @click="cameraCtrl(0,'down')" v-if="cameraTypeList[0]===1"
                  style="z-index:9999;position: absolute;color:  #000000;bottom: 0;left: 50%;transform: translateX(-50%);background-color: #0C5977;border: none">
            <Icon type="ios-arrow-down"/>
          </Button>
          <video id="container0">
          </video>
          <div v-if="playdescList[0] == 'offline'" class="playdesc">设备不在线</div>
          <div v-else class="cameradetail">{{ palyCameraInfoList[0] }}</div>
        </div>
        <div style="position: relative" :class="{'containeritem': 'true','videoFullScreen': isFullScreen}">
          <Button size="small" @click="cameraCtrl(1,'left')" v-if="cameraTypeList[1]===1"
                  style="z-index:9999;position: absolute;color: #000000;left: 0;top: 50%;transform: translateY(-50%);background-color: #0C5977;border: none">
            <Icon type="ios-arrow-back"/>
          </Button>
          <Button size="small" @click="cameraCtrl(1,'right')" v-if="cameraTypeList[1]===1"
                  style="z-index:9999;position: absolute;color:  #000000;right: 0;top: 50%;transform: translateY(-50%);background-color: #0C5977;border: none">
            <Icon type="ios-arrow-forward"/>
          </Button>
          <Button size="small" @click="cameraCtrl(1,'up')" v-if="cameraTypeList[1]===1"
                  style="z-index:9999;position: absolute;color:  #000000;top: 0;left: 50%;transform: translateX(-50%);background-color: #0C5977;border: none">
            <Icon type="ios-arrow-up"/>
          </Button>
          <Button size="small" @click="cameraCtrl(1,'down')" v-if="cameraTypeList[1]===1"
                  style="z-index:9999;position: absolute;color:  #000000;bottom: 0;left: 50%;transform: translateX(-50%);background-color: #0C5977;border: none">
            <Icon type="ios-arrow-down"/>
          </Button>
          <video id="container1">
          </video>
          <div v-if="playdescList[1] == 'offline'" class="playdesc">设备不在线</div>
          <div v-else class="cameradetail">{{ palyCameraInfoList[1] }}</div>
        </div>

      </div>
      <div>
        <div style="position: relative" :class="{'containeritem': 'true','videoFullScreen': isFullScreen}">
          <Button size="small" @click="cameraCtrl(2,'left')" v-if="cameraTypeList[2]===1"
                  style="z-index:9999;position: absolute;color: #000000;left: 0;top: 50%;transform: translateY(-50%);background-color: #0C5977;border: none">
            <Icon type="ios-arrow-back"/>
          </Button>
          <Button size="small" @click="cameraCtrl(2,'right')" v-if="cameraTypeList[2]===1"
                  style="z-index:9999;position: absolute;color:  #000000;right: 0;top: 50%;transform: translateY(-50%);background-color: #0C5977;border: none">
            <Icon type="ios-arrow-forward"/>
          </Button>
          <Button size="small" @click="cameraCtrl(2,'up')" v-if="cameraTypeList[2]===1"
                  style="z-index:9999;position: absolute;color:  #000000;top: 0;left: 50%;transform: translateX(-50%);background-color: #0C5977;border: none">
            <Icon type="ios-arrow-up"/>
          </Button>
          <Button size="small" @click="cameraCtrl(2,'down')" v-if="cameraTypeList[2]===1"
                  style="z-index:9999;position: absolute;color:  #000000;bottom: 0;left: 50%;transform: translateX(-50%);background-color: #0C5977;border: none">
            <Icon type="ios-arrow-down"/>
          </Button>
          <video id="container2">
          </video>
          <div v-if="playdescList[2] == 'offline'" class="playdesc">设备不在线</div>
          <div v-else class="cameradetail">{{ palyCameraInfoList[2] }}</div>
        </div>
        <div style="position: relative" :class="{'containeritem': 'true','videoFullScreen': isFullScreen}">
          <Button size="small" @click="cameraCtrl(3,'left')" v-if="cameraTypeList[3]===1"
                  style="z-index:9999;position: absolute;color: #000000;left: 0;top: 50%;transform: translateY(-50%);background-color: #0C5977;border: none">
            <Icon type="ios-arrow-back"/>
          </Button>
          <Button size="small" @click="cameraCtrl(3,'right')" v-if="cameraTypeList[3]===1"
                  style="z-index:9999;position: absolute;color:  #000000;right: 0;top: 50%;transform: translateY(-50%);background-color: #0C5977;border: none">
            <Icon type="ios-arrow-forward"/>
          </Button>
          <Button size="small" @click="cameraCtrl(3,'up')" v-if="cameraTypeList[3]===1"
                  style="z-index:9999;position: absolute;color:  #000000;top: 0;left: 50%;transform: translateX(-50%);background-color: #0C5977;border: none">
            <Icon type="ios-arrow-up"/>
          </Button>
          <Button size="small" @click="cameraCtrl(3,'down')" v-if="cameraTypeList[3]===1"
                  style="z-index:9999;position: absolute;color:  #000000;bottom: 0;left: 50%;transform: translateX(-50%);background-color: #0C5977;border: none">
            <Icon type="ios-arrow-down"/>
          </Button>
          <video id="container3">
          </video>
          <div v-if="playdescList[3] == 'offline'" class="playdesc">设备不在线</div>
          <div v-else class="cameradetail">{{ palyCameraInfoList[3] }}</div>
        </div>

      </div>
    </div>
  </div>

</template>
<script>
export default {
  name: "jessibuca-4",
  props: ['videolist', 'streamStatusList', 'isFullScreen', 'videonamelist', 'cameraTypeList', 'cameraDetailList'],
  data() {
    return {
      showOperateBtns: false,
      forceNoOffscreen: true,
      playList: [],
      playcount: 4,
      currentpage: 1,
      playdescList: [],
      palyCameraInfoList: ['', '', '', ''],
      reloadTimeOut: 5000,
      timeoutList: [-1, -1, -1, -1],
      currentvideolist: [],
      cameraTypeLists: [],
      cameraDetailsList: []
    }
  },
  mounted() {
    this.initPlayDescList();
    this.cameraTypeLists = this.cameraTypeList;
    this.cameraDetailsList = this.cameraDetailList;
    console.log('cameraDetailsList', this.cameraDetailList);
    this.batchCreate();
    this.batchPlayVideo();
  },
  destroyed() {
    this.batchDestoryVideo();
    this.initPlayDescList();
  },
  methods: {
    cameraCtrl(index, direction) {
      console.log(this.cameraDetailList)
      this.$http.get(`/api/operateCamera?command=${direction}&indexCode=${this.cameraDetailList[index].cameraindexcode}`).then(res => {
        console.log(res)
      })
    },
    initPlayDescList() {
      this.playdescList = new Array(4).fill('online');
    },
    create(id) {
      this.playList.push('');
    },
    batchCreate() {
      for (let i = 0; i < this.playcount; i++) {
        this.create(i);
      }
    },
    playVideo(index, videourl) {
      let flvPlayer = '';
      if (index < this.playList.length) {
        flvPlayer = this.playList[index];
        if (flvPlayer != '') {
          // flvPlayer.destroy();
          try {
            flvPlayer.unload();
            flvPlayer.detachMediaElement();
            flvPlayer.destroy();
            flvPlayer = '';
          } catch (err) {
            console.log('destory video error', err, 'index: ', index);
          }
        }
      }
      let $container = document.getElementById('container' + index);
      flvPlayer = flvjs.createPlayer({
        type: 'flv',
        url: videourl
      });

      flvPlayer.attachMediaElement($container);

      flvPlayer.on(flvjs.Events.ERROR, function (type) {
        console.log('flvjs.Events.ERROR: ', type, 'index: ', index)
        _this.reloadPlayer(index);
      })
      let _this = this;
      flvPlayer.on(flvjs.Events.LOADING_COMPLETE, function () {
        console.log('flvjs.Events.LOADING_COMPLETE: ', type, 'index: ', index)
        _this.reloadPlayer(index);
      })
      //muted
      flvPlayer.muted = true;
      flvPlayer.load();
      flvPlayer.play();
      this.playList[index] = flvPlayer;
    },

    reloadPlayer(index) {
      let _this = this;
      // console.log('index', index)
      if (this.timeoutList[index] == -1) {
        let timeoutid = setTimeout(function () {
          if (index < _this.currentvideolist.length) {
            let videourl = _this.currentvideolist[index];
            try {
              console.log('start reload : ', index, 'url: ', videourl)
              _this.playVideo(index, videourl)
              console.log('reload : ', index, 'url: ', videourl, 'finish')
            } catch (err) {
              console.log('restart ', index, ' player error')
            } finally {
              _this.timeoutList.splice(index, 1, -1);
            }
          }
        }, this.reloadTimeOut);
        this.timeoutList.splice(index, 1, timeoutid)
      }
    },
    batchPlayVideo(item) {
      let videolist = item[0];
      let streamStatusList = item[1];
      let cameraDetailList = item[2];
      for (let index = 0; index < this.playcount; index++) {
        if (streamStatusList[index] == 'online') {
          this.playVideo(index, videolist[index]);
          this.playdescList.splice(index, 1, 'online');
        } else if (streamStatusList[index] == 'offline') {
          this.playdescList.splice(index, 1, 'offline');
        } else {
          this.playdescList.splice(index, 1, '');
        }
      }
      this.palyCameraInfoList = cameraDetailList;
    },
    destoryVideo(index) {
      let player = this.playList[index];
      try {
        if (player) {
          player.unload();
          player.detachMediaElement();
          player.destroy();
          player = '';
        }
      } catch (err) {
        console.log('destory video error', err);

      }
      // if(player){
      //   try{
      //     player.destory();
      //   } catch(e){
      //     console.log('destory video error', e);
      //   }
      // }
    },
    batchDestoryVideo() {
      if (this.playList.length > 0) {

        for (let index = 0; index < this.playcount; index++) {
          this.destoryVideo(index);
        }
        this.playList = [];

      }
      for (let index = 0; index < this.timeoutList.length; index++) {
        if (this.timeoutList[index] != -1) {
          clearTimeout(this.timeoutList[index]);
        }
      }
      this.timeoutList = [-1, -1, -1, -1];
    },
    start() {
      this.batchDestoryVideo();
      this.batchCreate();
      this.batchPlayVideo(this.getPageVideoList(this.currentpage, this.playcount));
    },
    getPageVideoList(currentpage, playcount) {
      let start = (currentpage - 1) * playcount == 0 ? 0 : (currentpage - 1) * playcount;
      let videolist = this.videolist.slice(start, start + playcount);
      let streamStatusList = this.streamStatusList.slice(start, start + playcount);
      let cameraDetailList = this.videonamelist.slice(start, start + playcount);
      while (videolist.length < this.playcount) {
        videolist.push('');
        streamStatusList.push('');
        cameraDetailList.push('');
      }
      this.currentvideolist = videolist;
      return [videolist, streamStatusList, cameraDetailList]
    },
    switchplays(page) {
      this.currentpage = page;
      this.start();
    },
    switchStart() {
      this.currentpage = 1;
      this.start();
    },

    /*
    * 添加单个视频播放功能，供区域点位视频调用
    * date: 2023/02/15 16:59
    * created: lyy
    * */
    addSingleVideo(index, url, status) {
      if (status == 'online') {
        this.playVideo(index, url);
      }
      this.playdescList.splice(index, 1, status);
    },
    /**
     * 移除单个视频，供区域点位视频调用
     * date: 2023/02/15 17:24
     * created: lyy
     */
    removeSingleVideo(index) {
      if (this.playdescList[index] == 'online') {
        this.destoryVideo(index);
      }
      this.playdescList.splice(index, 1, '');
      this.playList.splice(index, 1, '');
    }


  }
}
</script>

<style scoped>
/*.jessibucadiv {*/
/*  display: flex;*/
/*  place-content: center;*/
/*  margin-top: 3rem;*/
/*}*/

/*.jessibucadiv{*/
/*  position: relative;*/
/*  width: 100vw;*/
/*  margin: 0px;*/
/*  padding: 0px;*/
/*}*/
/*.container-shell {*/
/*  backdrop-filter: blur(5px);*/
/*  background: hsla(0, 0%, 50%, 0.5);*/
/*  padding: 30px 4px 10px 4px;*/
/*  !* border: 2px solid black; *!*/
/*  width: auto;*/
/*  position: relative;*/
/*  border-radius: 5px;*/
/*  box-shadow: 0 10px 20px;*/
/*}*/
/*.flvh265div-4 .flvh265info{*/
/*  background-color: rgba(13, 14, 27, 0.7);;*/
/*}*/

.flvh265div-4 .containeritem {
  /*background: rgba(13, 14, 27, 0.7);*/
  margin-right: 5px;
  width: 49%;
  height: 30vh;
  display: inline-block;
  box-sizing: border-box;
  background: #000;
  position: relative;
}

.flvh265div-4 .containeritem video {
  /*background: rgba(13, 14, 27, 0.7);*/
  width: 100%;
  height: 100%;
  object-fit: fill;
}

.flvh265div-4 .containeritem.videoFullScreen {
  /*background: rgba(13, 14, 27, 0.7);*/
  width: 49%;
  height: 50vh;
  display: inline-block;
  box-sizing: border-box;
  background: #000;
  object-fit: fill;
}


.flvh265div-4 .containeritem .playdesc {
  /*height: 23vh;*/
  /*line-height: 23vh;*/
  vertical-align: center;
  top: 50%;
  position: absolute;
  left: 45%;
  z-index: 900;
}

.flvh265div-4 .containeritem .cameradetail {
  /*height: 23vh;*/
  /*line-height: 23vh;*/
  vertical-align: center;
  bottom: 10px;
  position: absolute;
  left: 10px;
  /*background-color: rgba(78, 182, 183, 0.3);*/
  padding: 2px;
  z-index: 900;
  /*color:#fff;*/
}

.flvh265div-4 .containeritem.videoFullScreen .cameradetail {
  font-size: 24px;
}

</style>
